import { IRequestCommand } from '../../authentication/connection/iRequestCommand';
import { ErrorDetails } from '../../authentication/connection/interfaces/apiInterfaces';
import { CommandRequestType } from '../../authentication/connection/commandRequestType';
import { ICommandParameters } from '../../authentication/connection/iCommandParameters';
import { ICommandResponse } from '../../authentication/connection/iCommandResponse';

export class RequestRegisterODNUserCommand extends IRequestCommand<
  ICommandResponse,
  ErrorDetails,
  IRequestRegisterODNUserParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.POST;
  override _commandUrl = 'odn/{carrierId}/requestRegisterUser';
  public override setParameters(parameters: IRequestRegisterODNUserParameters) {
    this._commandUrl = this._commandUrl.replace('{carrierId}', parameters.carrierId.toString());
    this._commandBody = parameters;
  }
}

export interface IRequestRegisterODNUserParameters extends ICommandParameters {
  carrierId: string;
  contact: string;
  phone: string;
  email: string;
  companyAddress: string;
  webUrl: string;
  company: string;
  userId: number;
  odnCode: string;
}
